import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paragraph from 'components/atoms/Paragraph';
import { fadeIn } from 'helpers/animations';

const Wrapper = styled.label`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  margin-top: 5px;
  cursor: pointer;
  animation: ${fadeIn} ${({ theme }) => theme.fadeInDown} ${({ delay }) => delay}s;

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.gray3};
  }
`;

const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 21px;
  height: 21px;
  background: ${({ checked, theme }) => (checked ? theme.blue : 'white')};
  border-radius: 3px;
  margin-right: 0.5rem;
  transition: box-shadow 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.blue};
  }
`;

const Checkmark = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

function File({ name, id, delay, setChecked, checked }) {
  const handleCheck = () => {
    if (checked) {
      setChecked((prevState) => prevState.filter((item) => item !== id));
    } else {
      setChecked((prevState) => [...prevState, id]);
    }
  };

  return (
    <Wrapper delay={delay}>
      <HiddenCheckbox type="checkbox" checked={checked} onChange={handleCheck} />
      <StyledCheckbox checked={checked}>
        <Checkmark viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Checkmark>
      </StyledCheckbox>
      <Paragraph>{name}</Paragraph>
    </Wrapper>
  );
}

File.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  setChecked: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  delay: PropTypes.number,
};

File.defaultProps = {
  delay: 1,
  checked: false,
};

export default File;
